:host {
  display: block;
  max-width: 100%;
}

#gz-metadata-header {
  font-size: var(--body-size);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: calc(4 * var(--spacer));
  border: 1px solid var(--chart-101-pressed-dividers);
  padding: calc(var(--spacer));
}

.metadata-header-values {
  font-weight: bold;
}

.gz-metadata-details {
  height: 6%;
  font-size: var(--body-size);
  display: flex;
  gap: calc(5 * var(--spacer));
  justify-content: flex-start;
  align-items: center;
  margin-left: calc(5 * var(--spacer));
}

gz-live-search-metadata-grid {
  height: calc(94% - 1px);
  padding-left: calc(5 * var(--spacer));
  padding-right: calc(5 * var(--spacer));
}
